import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import InputNumberFunc from "../../../../../../../function/InputNumberFunc";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { useFormik } from "formik";
import * as yup from "yup";
import countryJson from "../../../../../../localization/country.json";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../../navigationSection/BottomNavigationMobile";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { create_and_update_restaurant } from "../../../../../../../store/actions/authAction";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import isEmpty from "../../../../../../../store/validation/is-Empty";
import {
  DistanceData,
  OrderTimeSlots,
  MinimumLeadTime,
  CutOffTimeData,
} from "../../../../../../../enums/DropDownDataTable";

const validationSchema = yup.object({
  distance: yup.number().required("distance is required"),
  // max_date: yup
  //   .number()
  //   .required("placement is required")
  //   .min(1, "minimum 1 digit")
  //   .max(3, "maximum 3 digit"),
  cut_off_time: yup.number().required("cut off time is required"),
  auto_cancel: yup.number().required("auto cancel is required"),
  order_time_slot: yup.number().required("order time slot is required"),
  minimum_lead: yup.number().required("minimum lead time is required"),
});

export const EditCasualTakeaway = (props) => {
  let history = useHistory();
  //State
  const [state, setState] = useState({
    auto_accept: false,
    order_for_future: false,
    order_status_item_level: false,
  });

  const localizationText = useSelector((state) => {
    return !isEmpty(
      state?.auth?.user?.VendorUser?.country_code &&
        state?.auth?.user?.VendorUser?.country
    )
      ? state?.auth?.user?.VendorUser?.country_code +
          state?.auth?.user?.VendorUser?.country
      : "+91IN";
  });

  const onClickTakeAwayService = (type) => (e) => {
    if (type === "accept") {
      setState({
        ...state,
        auto_accept: !state.auto_accept,
      });
    } else if (type === "MaintainOrderStatus") {
      setState({
        ...state,
        order_status_item_level: !state.order_status_item_level,
      });
    } else {
      setState({
        ...state,
        order_for_future: !state.order_for_future,
      });
    }
  };

  useEffect(() => {
    setState({
      auto_accept:
        props.subscriptionData &&
        props.subscriptionData.auto_accept === undefined
          ? false
          : props.subscriptionData && props.subscriptionData.auto_accept,
      order_for_future:
        props.subscriptionData &&
        props.subscriptionData.order_for_future === undefined
          ? false
          : props.subscriptionData && props.subscriptionData.order_for_future,
      order_status_item_level:
        props.subscriptionData?.order_status_item_level === undefined
          ? false
          : props.subscriptionData?.order_status_item_level,
    });
    if (
      props.subscriptionData &&
      props.subscriptionData.distance !== undefined &&
      props.subscriptionData.distance !== null
    ) {
      formik.setFieldValue("distance", props.subscriptionData.distance);
    }
    if (
      props.subscriptionData &&
      props.subscriptionData.max_date !== undefined &&
      props.subscriptionData.max_date !== null
    ) {
      formik.setFieldValue("max_date", props.subscriptionData.max_date);
    }
    if (
      props.subscriptionData &&
      props.subscriptionData.cut_off_time !== undefined &&
      props.subscriptionData.cut_off_time !== null
    ) {
      formik.setFieldValue("cut_off_time", props.subscriptionData.cut_off_time);
    }
    if (
      props.subscriptionData &&
      props.subscriptionData.auto_cancel !== undefined &&
      props.subscriptionData.auto_cancel !== null
    ) {
      formik.setFieldValue("auto_cancel", props.subscriptionData.auto_cancel);
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.order_time_slot !== undefined &&
      props?.subscriptionData?.order_time_slot !== null
    ) {
      formik.setFieldValue(
        "order_time_slot",
        props?.subscriptionData?.order_time_slot
      );
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.minimum_lead !== undefined &&
      props?.subscriptionData?.minimum_lead !== null
    ) {
      formik.setFieldValue(
        "minimum_lead",
        props?.subscriptionData?.minimum_lead
      );
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.auto_cancel_open_restaurant !== undefined &&
      props?.subscriptionData?.auto_cancel_open_restaurant !== null
    ) {
      formik.setFieldValue(
        "auto_cancel_open_restaurant",
        props?.subscriptionData &&
          props?.subscriptionData?.auto_cancel_open_restaurant
      );
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.auto_cancel_close_restaurant !== undefined &&
      props?.subscriptionData?.auto_cancel_close_restaurant !== null
    ) {
      formik.setFieldValue(
        "auto_cancel_close_restaurant",
        props?.subscriptionData &&
          props?.subscriptionData?.auto_cancel_close_restaurant
      );
    }
  }, [props.subscriptionData]);

  const formik = useFormik({
    initialValues: {
      distance: "",
      max_date: "",
      cut_off_time: "",
      auto_cancel: "",
      order_time_slot: 15,
      minimum_lead: 15,
      auto_cancel_open_restaurant: 1,
      auto_cancel_close_restaurant: 5,
    },
    validationSchema,

    onSubmit: (values) => {
      let valueData = {
        value:
          state.auto_accept === false &&
          state.order_for_future === false &&
          state.order_status_item_level === false &&
          values.distance === "" &&
          values.cut_off_time === "" &&
          values.auto_cancel === ""
            ? false
            : true,
        auto_accept: state.auto_accept,
        order_for_future: state.order_for_future,
        order_status_item_level: state.order_status_item_level,
        distance: values.distance,
        max_date: values.max_date,
        cut_off_time: values.cut_off_time,
        // auto_cancel: values.auto_cancel,
        order_time_slot: values.order_time_slot,
        minimum_lead: values.minimum_lead,
        auto_cancel_open_restaurant: values.auto_cancel_open_restaurant,
        auto_cancel_close_restaurant: values.auto_cancel_close_restaurant,
      };

      const token = props.auth.user.accessToken;
      const subscriptionId = props.subscription._id;
      let formData = props.allSubscriptionsData;
      if (props?.casualDiningService) {
        formData.casual_dining_status.ordering.take_away = valueData;
      } else if (props?.fastFoodDiningService) {
        formData.fast_food_dining_status.ordering.take_away = valueData;
      } else if (props?.multiDiningService) {
        formData.multi_service_business_status.ordering.take_away = valueData;
      }
      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onSuccess = (e) => {
    if (state.auto_accept === false) {
      let takeAwayData = props.onboarding?.orderAutoAcceptSetting;
      takeAwayData.take_away = false;
      const sessionSetings = {
        id: props.onboarding._id,
        vendor_id: props.onboarding.vendor_id,
        orderAutoAcceptSetting: takeAwayData,
      };
      props.create_and_update_restaurant(sessionSetings);
    }
    Alert.success("<h4>Take away changes add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/edit-ordering-subscription");
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  // useEffect(() => {
  //   formik.setFieldValue("max_date", "");
  // }, []);
  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.distance) {
      let distanceElement = document.getElementById("distance");
      distanceElement.focus();
    }
    // else if (formik.errors && formik.errors.max_date) {
    //   let max_dateElement = document.getElementById("max_date");
    //   max_dateElement.focus();
    // }
    else if (formik.errors && formik.errors.cut_off_time) {
      let cut_off_timeElement = document.getElementById("cut_off_time");
      cut_off_timeElement.focus();
    } else if (formik.errors && formik.errors.auto_cancel) {
      let auto_cancelElement = document.getElementById("auto_cancel");
      auto_cancelElement.focus();
    } else if (formik.errors && formik.errors.order_time_slot) {
      let order_time_slotElement = document.getElementById("order_time_slot");
      order_time_slotElement.focus();
    } else if (formik.errors && formik.errors.minimum_lead) {
      let minimum_leadElement = document.getElementById("minimum_lead");
      minimum_leadElement.focus();
    }
  }, [count]);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const [disabled, setDisable] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/edit-ordering-subscription"
                displayText="Back"
              />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className="mb-4">
                  <TopTextReusableComponent
                    headingText="Take Away Ordering Settings"
                    // displayEdit={state.editButton}
                    // onClickEdit={editClick}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between pt-3">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Auto - Accept
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={state.auto_accept}
                      checkedBox={state.auto_accept}
                      onChange={onClickTakeAwayService("accept")}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={disabled}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-4">
                  <div className="f12-500 col-6 col-md-7 col-lg-6 p-0">
                    Distance
                  </div>
                  <div className="col-6 col-md-5 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                // label="Kilometers"
                                name="distance"
                                id="distance"
                                disabled={disabled}
                                className={`w-100 ${
                                  formik.errors.distance &&
                                  formik.touched.distance
                                    ? "enError outlined-KilometersAway"
                                    : "outlined-KilometersAway"
                                }`}
                                onChange={formik.handleChange}
                                value={formik.values.distance}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.distance &&
                                  formik.touched.distance
                                }
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {DistanceData.map((data, index) => {
                                  return (
                                    <MenuItem key={index} value={data.value}>
                                      {data.title}
                                    </MenuItem>
                                  );
                                })}
                                {/* <MenuItem value={10000}>No Limit</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={30}>30</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={1}>1</MenuItem> */}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <Media query="(min-width: 992px)">
                              <p className="f12-500">
                                {countryJson[localizationText] &&
                                  countryJson[localizationText].distance}
                              </p>
                            </Media>
                            <Media query="(max-width: 992px)">
                              <p className="f12-500">
                                KM
                                <br />
                                away
                              </p>
                            </Media>
                          </div>
                          <div className="col-6">
                            {formik.errors.distance &&
                            formik.touched.distance ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.distance}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-4">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Orders Enabled for Future Date and Time
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={state.order_for_future}
                      checkedBox={state.order_for_future}
                      onChange={onClickTakeAwayService("FutureOrder")}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={disabled}
                    />
                  </div>
                </div>
                {state.order_for_future ? (
                  <div className="d-flex align-items-center justify-content-between pt-3">
                    <div className=" col-6 col-md-8 col-lg-6 p-0">
                      <div className="f12-500">
                        Placement cannot come more than
                      </div>
                    </div>
                    <div className="col-6 col-md-4 col-lg-6">
                      <Row>
                        <Col md={12}>
                          <div className="row align-items-center">
                            <div className="col-9 col-md-6">
                              <FormControl
                                variant="outlined"
                                disabled={disabled}
                                className={"w-100"}
                              >
                                <NewInputText
                                  controlClass={"max_date"}
                                  extraClass={`mb-1 ${
                                    formik.errors.max_date &&
                                    formik.touched.max_date
                                      ? "enError"
                                      : ""
                                  }`}
                                  disabled={disabled}
                                  inputType="number"
                                  onInput={maxLengthCheck}
                                  maxLength={2}
                                  onKeyDown={InputNumberFunc}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  // labelText="Days"
                                  name="max_date"
                                  onChange={formik.handleChange}
                                  value={formik.values.max_date}
                                  onFocusOut={formik.handleBlur}
                                />
                              </FormControl>
                            </div>
                            <div className="col-md-6 col-3">
                              <p className="f12-500">Days</p>
                            </div>
                            <div className="col-6">
                              {/* {formik.errors.max_date && formik.touched.max_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.max_date}
                            </div>
                          ) : null} */}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                ) : null}

                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-7 col-lg-6 p-0">
                    *Takeaway Time Slot
                    <div className="f11-400 opacity5">
                      (Users will be given slots in these intervals to make
                      takeaway request during next business hours)
                    </div>
                  </div>

                  <div className="col-6 col-md-5 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                name="order_time_slot"
                                id="order_time_slot"
                                disabled={disabled}
                                className={`w-100 ${
                                  formik.errors.order_time_slot &&
                                  formik.touched.order_time_slot
                                    ? "enError outlined-KilometersAway"
                                    : "outlined-KilometersAway"
                                }`}
                                onChange={formik.handleChange}
                                value={formik.values.order_time_slot}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.order_time_slot &&
                                  formik.touched.order_time_slot
                                }
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {OrderTimeSlots &&
                                  OrderTimeSlots.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <p className="f12-500">Minutes</p>
                          </div>
                          <div className="col-6">
                            {formik.errors.order_time_slot &&
                            formik.touched.order_time_slot ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.order_time_slot}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-7 col-lg-6 p-0">
                    *Minimum Lead Time
                    <div className="f11-400 opacity5">
                      (Amount of time from opening of the restaurant to deliver
                      first order)
                    </div>
                  </div>
                  <div className="col-6 col-md-5 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                name="minimum_lead"
                                id="minimum_lead"
                                disabled={disabled}
                                className={`w-100 ${
                                  formik.errors.minimum_lead &&
                                  formik.touched.minimum_lead
                                    ? "enError outlined-KilometersAway"
                                    : "outlined-KilometersAway"
                                }`}
                                onChange={formik.handleChange}
                                value={formik.values.minimum_lead}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.minimum_lead &&
                                  formik.touched.minimum_lead
                                }
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {MinimumLeadTime &&
                                  MinimumLeadTime.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <p className="f12-500">Minutes</p>
                          </div>
                          <div className="col-6">
                            {formik.errors.minimum_lead &&
                            formik.touched.minimum_lead ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.minimum_lead}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between pt-4">
                  <div className=" col-6 col-md-8 col-lg-6 p-0">
                    <div className="f12-500">Cut Off Time - Order</div>
                    <div className="f11-400 opacity5">
                      (Last Order as per the Hours of Operation)
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                // label="Minutes"
                                name="cut_off_time"
                                disabled={disabled}
                                id="cut_off_time"
                                className={`w-100 ${
                                  formik.errors.cut_off_time &&
                                  formik.touched.cut_off_time
                                    ? "enError outlined-Minutes"
                                    : "outlined-Minutes"
                                }`}
                                onChange={formik.handleChange}
                                value={formik.values.cut_off_time}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.cut_off_time &&
                                  formik.touched.cut_off_time
                                }
                                // className="outlined-Minutes"
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {CutOffTimeData &&
                                  CutOffTimeData.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <Media query="(min-width:991px)">
                              <p className="f12-500">Minutes</p>
                            </Media>
                            <Media query="(max-width:991px)">
                              <p className="f12-500">Mins</p>
                            </Media>
                          </div>
                          <div className="col-6">
                            {formik.errors.cut_off_time &&
                            formik.touched.cut_off_time ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.cut_off_time}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="row mb-3 mt-4">
                  <div className=" col-6 col-md-6 col-lg-6">
                    <div className="f12-500">
                      Auto Cancel&nbsp;
                      <i
                        className="fa fa-info-circle"
                        style={{ color: "#9E9E9E" }}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div className="f11-400 opacity5">
                      (Acceptance period for pending requests when restaurant is
                      open)
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-lg-3">
                    <Row>
                      <Col md={12}>
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                          disabled={true}
                        >
                          <NewInputText
                            extraClass="mb-1"
                            name="auto_cancel_open_restaurant"
                            disabled={true}
                            onInput={maxLengthCheck}
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            inputType="number"
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.auto_cancel_open_restaurant}
                            // labelText="Minutes"
                            controlClass="auto_cancel_open_restaurant"
                          />
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="col-3 f12-500 m-auto">Minutes</div>
                </div>
                <div className="row mb-3">
                  <div className=" col-6 col-md-6 col-lg-6">
                    <div className="f12-500">
                      Auto Cancel&nbsp;
                      <i
                        className="fa fa-info-circle"
                        style={{ color: "#9E9E9E" }}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div className="f11-400 opacity5">
                      (Acceptance period for pending requests when restaurant is
                      close)
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-lg-3">
                    <Row>
                      <Col md={12}>
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                          disabled={disabled}
                        >
                          <NewInputText
                            extraClass="mb-1"
                            name="auto_cancel_close_restaurant"
                            disabled={true}
                            onInput={maxLengthCheck}
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            inputType="number"
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.auto_cancel_close_restaurant}
                            // labelText="Minutes"
                            controlClass="auto_cancel_close_restaurant"
                          />
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="col-3 f12-500 m-auto">Minutes</div>
                </div>
                {/* <div className="d-flex align-items-center justify-content-between pt-4">
                  <div className=" col-6 col-md-8 col-lg-6 p-0">
                    <div className="f12-500">Auto Cancel</div>
                    <div className="f11-400 opacity5">
                      Pending Orders have to be accepted within Specified period
                      Otherwise it will be cancelled
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                // label="Minutes"
                                name="auto_cancel"
                                id="auto_cancel"
                                disabled={disabled}
                                className={`w-100 ${
                                  formik.errors.auto_cancel &&
                                  formik.touched.auto_cancel
                                    ? "enError outlined-Minutes"
                                    : "outlined-Minutes"
                                }`}
                                onChange={formik.handleChange}
                                value={formik.values.auto_cancel}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.auto_cancel &&
                                  formik.touched.auto_cancel
                                }
                                // className="outlined-Minutes"
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                <MenuItem value={5}>5 </MenuItem>
                                <MenuItem value={10}>10 </MenuItem>
                                <MenuItem value={15}>15 </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <Media query="(min-width:991px)">
                              <p className="f12-500">Minutes</p>
                            </Media>
                            <Media query="(max-width:991px)">
                              <p className="f12-500">Mins</p>
                            </Media>
                          </div>
                          <div className="col-6">
                            {formik.errors.auto_cancel &&
                            formik.touched.auto_cancel ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.auto_cancel}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                */}
                <div className="d-flex justify-content-between py-4">
                  <div className=" col-6 col-md-8 col-lg-6 p-0">
                    <div className="f12-500">
                      Maintain order status on item level
                    </div>
                    <div className="f11-400 opacity5 w-75">
                      (Enable this to maintain order status like accepted,
                      getting prepared etc on item level. If you don't enable
                      this it will be maintained on order level)
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={state.order_status_item_level}
                      checkedBox={state.order_status_item_level}
                      onChange={onClickTakeAwayService("MaintainOrderStatus")}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={disabled}
                    />
                  </div>
                </div>
                {/* <ReuseForm /> */}
                <div
                  className="onboarding-map-setup-screen-autodetect-button pt-4"
                  style={{ marginBottom: "50px" }}
                >
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link="/edit-ordering-subscription"
                  />
                  {!disabled && (
                    <ReusableOnboardingButton
                      buttonTitle="Done Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Done"
                      buttonType="button"
                      onClick={() => onClickSave()}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </React.Fragment>
    );
  }
};

EditCasualTakeaway.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  create_and_update_restaurant: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state?.onboarding && state?.onboarding?.restaurantDetails,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  subscriptionData:
    state?.onboarding?.onboard_subscription_details?.casual_dining &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.ordering?.take_away
      : state?.onboarding?.onboard_subscription_details?.fast_food_dining &&
        state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
      ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
          ?.ordering?.take_away
      : state?.onboarding?.onboard_subscription_details
          ?.multi_service_business_status?.ordering?.take_away,
  allSubscriptionsData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  create_and_update_restaurant,
})(withRouter(EditCasualTakeaway));
